"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapAvailableCountries = function mapAvailableCountries(countries) {
  return countries.map(function (country) {
    return {
      id: country.id,
      label: country.full_name_locale
    };
  });
};
var _default = mapAvailableCountries;
exports["default"] = _default;